export const getProgressColor = (value) => {
  if (value <= 45) return "#ED0000";
  if (value < 75) return "#f29100";
  if (value === 75) return "#f29100";
  return "#378000";
};

export const getRiskStyle = (risk) => {
  if (risk === "Low Risk") {
    return { background: "#DBF3E2", color: "#0a1a27" };
  }
  if (risk === "Medium Risk") {
    return { background: "#FFE0B2", color: "#C54C1F" };
  }
  if (risk === "High Risk") {
    return { background: "#F8D7DA", color: "#721C24" };
  }
  return {};
};
